import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * ShadCN sonner Toaster. Mounted ONCE in __root.tsx so any feature can call
 * `toast(...)` from `sonner` for mutation feedback.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      position="top-center"
      className="toaster group"
      // Radix modal sheets/dialogs set `pointer-events: none` on <body>, which
      // toasts inherit — leaving action buttons (e.g. Undo) visible but dead.
      // Force them interactive regardless of open overlays.
      toastOptions={{ style: { pointerEvents: 'auto' } }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
